import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { createSelector } from "reselect";
import { FORM_FIELD_TYPE } from "../../../../../constants";
import { bindDispatch } from "../../../../../utils";
import RightPanel from "../../../../common/RightPanel";
import Form from "../../../../common/Form";
import styles from "../../../../../styles/Inventory/Settings.module.scss";

const BOOL_OPTIONS = [
  { id: "true", value: "True" },
  { id: "false", value: "False" },
];

/**
 * EditControlConfigFlag — side panel for editing a single boolean control config flag.
 *
 * Props:
 *   flagKey      — one of: preventSkip | agentQEnabled | canEditTemplate | canChangePosition
 *   heading      — panel heading (flag display name)
 *   description  — explanatory text shown below the dropdown
 *   currentValue — current boolean value (or null/undefined if not set)
 *   onSave       — callback(value: boolean)
 */
export class EditControlConfigFlag extends Component {
  constructor(props) {
    super(props);
    const toStr = (v) => (v === true ? "true" : v === false ? "false" : null);
    this.state = {
      selected: toStr(props.currentValue),
      originalSelected: toStr(props.currentValue),
    };
  }

  closeEditPanel = () => {
    const {
      actions,
      history,
      match: { params },
    } = this.props;
    actions.cancelSettingEdit();
    history.push(`/screens/${params.screenId}/${params.tabId}`);
  };

  handleChange = ([data]) => {
    this.setState({ selected: data.id });
  };

  handleSave = () => {
    const { onSave } = this.props;
    if (this.state.selected !== null) {
      onSave(this.state.selected === "true");
    }
  };

  isSaveEnabled = () =>
    this.state.selected !== null && this.state.selected !== this.state.originalSelected;

  render() {
    const { heading, description, screenSettingsEdit } = this.props;
    const { selected } = this.state;

    return (
      <RightPanel
        isOpen={screenSettingsEdit.isOpen}
        onClose={this.closeEditPanel}
        header={heading}
        showFooter
        width={360}
        primaryButtonProps={{
          text: "Button.save",
          onClick: this.handleSave,
          disabled: !this.isSaveEnabled(),
        }}
        secondaryButtonProps={{ text: "Button.cancel", onClick: this.closeEditPanel }}
      >
        <div className={styles.editControlConfig}>
          {description && <p className={styles.controlConfigDescription}>{description}</p>}
          <Form
            config={[
              {
                id: "value",
                title: "Value",
                label: "",
                singleSelect: true,
                showLabelInButton: false,
                type: FORM_FIELD_TYPE.SELECT,
                className: styles.controlConfigDropdown,
                placeHolder: "Select",
                usePortal: false,
                list: BOOL_OPTIONS,
                selectedList: selected ? [BOOL_OPTIONS.find((o) => o.id === selected)] : [],
                onSelect: this.handleChange,
              },
            ]}
          />
        </div>
      </RightPanel>
    );
  }
}

const mapStateToProps = createSelector(
  (state) => state.screens,
  (screens) => ({ screenSettingsEdit: screens.screenSettingsEdit || {} })
);

export default withRouter(connect(mapStateToProps, bindDispatch)(EditControlConfigFlag));
